import { render, staticRenderFns } from "./adress.vue?vue&type=template&id=00554f12&"
import script from "./adress.vue?vue&type=script&lang=js&"
export * from "./adress.vue?vue&type=script&lang=js&"
import style0 from "./adress.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00554f12')) {
      api.createRecord('00554f12', component.options)
    } else {
      api.reload('00554f12', component.options)
    }
    module.hot.accept("./adress.vue?vue&type=template&id=00554f12&", function () {
      api.rerender('00554f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/carouselMangent/components/adress.vue"
export default component.exports